/**
 * wholesale-tier-pricing.js -pmcode APR21
 *
 * Handles dynamic tier-based variant selection on the product page.
 *
 * Responsibilities:
 *  1. Hide the "Tier" option UI so customers never see it
 *  2. On page load: swap the form's variant ID to the customer's tier variant
 *  3. On option change: re-map to the correct tier variant
 *  4. Update displayed price to match the billing variant
 *  5. Final safety net: intercept form submit to enforce correct ID
 *
 * Depends on: window.wholesaleTierData (injected by wholesale-tier-price.liquid)
 *
 * Compatible with: Dawn and most modern Shopify themes that use
 *   - <input type="hidden" name="id"> in the add-to-cart form
 *   - Standard option radio/select inputs
 */

(function () {
    'use strict';
  
    // ── Guard ──────────────────────────────────────────────────────────────────
    const data = window.wholesaleTierData;
    if (!data) {
      console.warn('[WholesaleTier] No tier data found. Is the snippet rendered?');
      return;
    }
  
    const {
      customerTier,
      tierOptionIndex,
      variants
    } = data;
  
    // No tier option on this product — nothing to do
    if (tierOptionIndex < 0) return;
  
    // ── Money formatting ───────────────────────────────────────────────────────
// Uses Shopify's moneyFormat (e.g. "${{amount}}") injected via
// wholesaleTierData to ensure the JS-rendered price always matches the
// server-side Liquid output. Previously used Intl.NumberFormat, which rendered
// inconsistently across browser locales when navigating to a variant URL directly.
    function formatMoney(cents) {
        try {
          const amount = (cents / 100).toFixed(2);
          const fmt = data.moneyFormat || '${{amount}}';
          return fmt.replace('{{amount}}', amount)
                    .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
                    .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }
  
    // ── Core: find the tier-correct billing variant ────────────────────────────
    // Given any variant, returns the sibling variant whose Tier option
    // matches the customer tier, while all other options stay the same.
    function findBillingVariant(referenceVariant) {
      if (!referenceVariant) return null;
  
      return variants.find(function (v) {
        // All non-tier options must match
        for (var i = 0; i < v.options.length; i++) {
          if (i === tierOptionIndex) {
            // This position must equal the customer tier
            if (v.options[i].toLowerCase() !== customerTier) return false;
          } else {
            // Every other position must match the reference variant
            if (v.options[i] !== referenceVariant.options[i]) return false;
          }
        }
        return true;
      }) || null;
    }
  
    // ── Get current variant from the form ─────────────────────────────────────
    function getCurrentVariantFromForm() {
      const input = getFormIdInput();
      if (!input) return null;
      const id = parseInt(input.value, 10);
      return variants.find(function (v) { return v.id === id; }) || null;
    }
  
    // ── DOM helpers ───────────────────────────────────────────────────────────
    function getFormIdInput() {
      return (
        document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        document.querySelector('form[action="/cart/add"] input[name="id"]') ||
        document.querySelector('.product-form input[name="id"]')
      );
    }
  
    // function getPriceDisplay() {
    //   return document.querySelector('.wholesale-tier-price__amount');
    // }
    function getPriceDisplay() {
  return document.querySelector('[id^="custom-price-"] .price-item--regular');
}
  
    // function getComparePriceDisplay() {
    //   return document.querySelector('.wholesale-tier-price__compare');
    // }
    function getComparePriceDisplay() {
  return document.querySelector('[id^="custom-price-"] .price__sale s.price-item--regular');
}
  
    // ── Update form ID ─────────────────────────────────────────────────────────
    function updateFormVariantId(variantId) {
      const input = getFormIdInput();
      if (input) {
        input.value = variantId;
      }
    }
  
    // ── Update price display ───────────────────────────────────────────────────
    function updatePriceDisplay(variant) {
      const priceEl = getPriceDisplay();
      const compareEl = getComparePriceDisplay();
  
      if (priceEl && variant) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.setAttribute('data-variant-id', variant.id);
      }
  
      if (compareEl && variant) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }
  
    // ── Apply tier to current state ────────────────────────────────────────────
    function applyTier() {
      const currentVariant = getCurrentVariantFromForm();
      if (!currentVariant) return;
  
      const billingVariant = findBillingVariant(currentVariant);
      if (!billingVariant) {
        console.warn('[WholesaleTier] No billing variant found for tier:', customerTier, 'from variant:', currentVariant.id);
        return;
      }
  
   updateFormVariantId(billingVariant.id);
    }
  
    // ── Hide Tier option from the UI ───────────────────────────────────────────
    // Targets common selector patterns across Dawn and popular themes.
    // Extend this if your theme uses different markup.
    function hideTierOptionUI() {
      var hidden = false;
  
      // Pattern 1: fieldset with data-option-name (Dawn 2+)
      document.querySelectorAll('fieldset[data-option-name]').forEach(function (el) {
        if (el.getAttribute('data-option-name') === 'Tier') {
          el.style.display = 'none';
          hidden = true;
        }
      });
  
      // Pattern 2: .product-form__input wrapper with legend/label text "Tier"
      document.querySelectorAll('.product-form__input, .selector-wrapper, .variant__input-wrap').forEach(function (el) {
        var label = el.querySelector('legend, label, .form__label');
        if (label && label.textContent.trim() === 'Tier') {
          el.style.display = 'none';
          hidden = true;
        }
      });
  
      // Pattern 3: select element with option values that look like tiers
      document.querySelectorAll('select').forEach(function (el) {
        if (el.id && el.id.toLowerCase().includes('tier')) {
          var wrapper = el.closest('.selector-wrapper, .product-form__input, fieldset') || el.parentElement;
          if (wrapper) wrapper.style.display = 'none';
          hidden = true;
        }
      });
  
      if (!hidden) {
        console.warn('[WholesaleTier] Could not find Tier option UI to hide. Check your theme markup and update hideTierOptionUI() selectors.');
      }
    }
  
    // ── Listen for option changes ──────────────────────────────────────────────
    // Listens on the document and re-applies tier after Shopify's own
    // variant selection logic has had a chance to update the form input.
    function listenForVariantChanges() {
  
      // Method 1: Shopify's variant:change custom event (Dawn and modern themes)
      document.addEventListener('variant:change', function () {
        setTimeout(applyTier, 0);
      });
  
      // Method 2: Standard input change (radio buttons / selects for options)
      document.addEventListener('change', function (e) {
        var target = e.target;
  
        // Ignore changes to the form id input itself (would cause infinite loop)
        if (target.name === 'id') return;
  
        // Ignore tier option changes (shouldn't happen since it's hidden, but safety net)
        if (target.closest('[data-option-name="Tier"]')) return;
  
        // If it looks like a product option input, re-apply tier after a tick
        if (
          target.matches('[name^="options["]') ||
          target.matches('select[id*="option"], select[name*="option"]') ||
          target.matches('.product-form__input input[type="radio"]') ||
          target.closest('.variant-input-wrap, .product-form__input, .selector-wrapper')
        ) {
          setTimeout(applyTier, 50);
        }
      });
  
      // Method 3: Observe form id input changes set by Shopify's own JS
      // This is the most robust fallback for themes that use their own JS
      var formInput = getFormIdInput();
      if (formInput && typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'value') {
              // Only react if the value was NOT set by our own code
              var newId = parseInt(formInput.value, 10);
              var currentTierVariant = findBillingVariant(
                variants.find(function (v) { return v.id === newId; })
              );
              if (currentTierVariant && currentTierVariant.id !== newId) {
                applyTier();
              }
            }
          });
        });
        observer.observe(formInput, { attributes: true });
      }
    }
  
    // ── Form submit safety net ─────────────────────────────────────────────────
    // Final enforcement: ensure the correct billing variant ID is always
    // submitted, even if theme JS updated the input after our last applyTier().
    function interceptFormSubmit() {
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form.action || !form.action.includes('/cart/add')) return;
  
        var input = form.querySelector('input[name="id"]');
        if (!input) return;
  
        var variantId = parseInt(input.value, 10);
        var variant = variants.find(function (v) { return v.id === variantId; });
        if (!variant) return;
  
        var billingVariant = findBillingVariant(variant);
        if (billingVariant && billingVariant.id !== variantId) {
          input.value = billingVariant.id;
        }
      }, true); // capture phase so we run before any other submit handlers
    }
  
    // ── Init ───────────────────────────────────────────────────────────────────
    function init() {
      hideTierOptionUI();
      applyTier();
      listenForVariantChanges();
      interceptFormSubmit();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
  })();
  